<!-- Virtual Table -->
<cdk-virtual-scroll-viewport itemSize="33" minBufferPx="200" maxBufferPx="400"
	#scrollComponent
	#virtualizedDropList
	cdkDropList
	[cdkDropListData]="null"
	(cdkDropListDropped)="fieldDrop.emit($event)"
	[ngStyle]="{
		'width': width,
		'height': height
	}"
	class="mat-table">

	<!-- Rows -->
	<div *cdkVirtualFor="let datum of filterShown(); let i = index;"
		[ngClass]="{
			'selectedRow': datum.selected,
			'mat-header-row': datum.header,
			'mat-row': !datum.header
		}"
		[tabIndex]="datum.allowTab ? '0' : '-1'"
		[attr.aria-label]="datum.ariaLabel"
		(click)="rowClick(datum); datum.click($event, datum)"
		(keydown)="rowKeydown(datum, $event); datum.keydown($event, datum)">

		<!-- Spacers (for detail rows) -->
		<div *ngFor="let i of createRange(datum.level); trackBy: trackByID;"
			class="spacer"
			[ngStyle]="{
				'background-color': datum.parentSelected(datum.level - i) ? 'whitesmoke' : 'white',
				'flex-basis': paddingLeftPerLevel + 'px'
			}"></div>

		<!-- Virtual Row -->
		<div class="virtualRow"
			[ngStyle]="{
				'border-top-width': datum.header ? '0px' : '1px',
				'background': datum.header ? 'white' : 'inherit',
				'border-bottom': datum.showChildren && datum.hasChildren ? '' : '1px solid rgba(0, 0, 0, .12)',
				'margin-top': datum.header ? '-1px' : '0'
			}"
			cdkDropList
			[cdkDropListConnectedTo]="draggableConnectedLists">

			<!-- Draggable Handle -->
			<div class="dragHandle"
				cdkDrag
				[cdkDragDisabled]="!draggableIdentifiers.includes(datum.identifier) || datum.header"
				[cdkDragData]="datum.data"
				(cdkDragStarted)="dragStart.emit(datum)"
				(cdkDragEnded)="dragEnd.emit(datum)">

				<!-- Cells -->
				<div *ngFor="let column of columns[datum.identifier]"
					class="mat-column-{{column}} column"
					[ngStyle]="datum.style">
					<div [ngClass]="{
							'mat-header-cell': datum.header,
							'mat-cell': !datum.header
						}"
						class="truncate">
						<ng-container *ngTemplateOutlet="cellTemplate; context: {
							datum: datum,
							column: column
						}"></ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</cdk-virtual-scroll-viewport>
